<th>
  <span></span>
</th>
<th>
  <a (click)="sortBy('name')">
    <span>{{ "homepage.lists.column_pia" | translate }}</span>
    @if (sortValue === 'name' && sortOrder == 'up') {
    <span>
      <fa-icon [icon]="faCaretUp"></fa-icon>
    </span>
    } @else {
    <span>
      <fa-icon
        [icon]="faCaretDown"
        [ngClass]="sortValue === 'name' ? '' : 'deactivate'"
      ></fa-icon>
    </span>
    }
  </a>
</th>
<th>
  <a (click)="sortBy('updated_at')">
    <span>{{ "homepage.lists.column_updated_at" | translate }}</span>
    @if ( sortValue === 'updated_at' && sortOrder == 'up') {
    <span>
      <fa-icon [icon]="faCaretUp"></fa-icon>
    </span>
    } @else {
    <span>
      <fa-icon
        [icon]="faCaretDown"
        [ngClass]="sortValue === 'updated_at' ? '' : 'deactivate'"
      ></fa-icon>
    </span>
    }
  </a>
</th>
<th>
  <a (click)="sortBy('author_name')">
    <span>{{ "homepage.lists.column_author" | translate }}</span>
    @if ( sortValue === 'author_name' && sortOrder == 'up') {
    <span>
      <fa-icon [icon]="faCaretUp"></fa-icon>
    </span>
    } @else {
    <span>
      <fa-icon
        [icon]="faCaretDown"
        [ngClass]="sortValue === 'author_name' ? '' : 'deactivate'"
      ></fa-icon>
    </span>
    }
  </a>
</th>
<th>
  <a (click)="sortBy('evaluator_name')">
    <span>{{ "homepage.lists.column_evaluation" | translate }}</span>
    @if ( sortValue === 'evaluator_name' && sortOrder == 'up') {
    <span>
      <fa-icon [icon]="faCaretUp"></fa-icon>
    </span>
    } @else {
    <span>
      <fa-icon
        [icon]="faCaretDown"
        [ngClass]="sortValue === 'evaluator_name' ? '' : 'deactivate'"
      ></fa-icon>
    </span>
    }
  </a>
</th>
<th>
  <a (click)="sortBy('validator_name')">
    <span>{{ "homepage.lists.column_validation" | translate }}</span>
    @if ( sortValue === 'validator_name' && sortOrder == 'up') {
    <span>
      <fa-icon [icon]="faCaretUp"></fa-icon>
    </span>
    } @else {
    <span>
      <fa-icon
        [icon]="faCaretDown"
        [ngClass]="sortValue === 'validator_name' ? '' : 'deactivate'"
      ></fa-icon>
    </span>
    }
  </a>
</th>
@if (authService.state) {
<th>
  <a (click)="sortBy('guests')">
    <span>Invité(s)</span>
    @if ( sortValue === 'guests' && sortOrder == 'up') {
    <span>
      <fa-icon [icon]="faCaretUp"></fa-icon>
    </span>
    } @else {
    <span>
      <fa-icon
        [icon]="faCaretDown"
        [ngClass]="sortValue === 'guests' ? '' : 'deactivate'"
      ></fa-icon>
    </span>
    }
  </a>
</th>
}
<th>
  <a (click)="sortBy('structure_name')">
    <span>{{ "homepage.lists.column_structure_name" | translate }}</span>
    @if ( sortValue === 'structure_name' && sortOrder == 'up') {
    <span>
      <fa-icon [icon]="faCaretUp"></fa-icon>
    </span>
    } @else {
    <span>
      <fa-icon
        [icon]="faCaretDown"
        [ngClass]="sortValue === 'structure_name' ? '' : 'deactivate'"
      ></fa-icon>
    </span>
    }
  </a>
</th>
<th>
  <a (click)="sortBy('progress')">
    <span>{{ "homepage.lists.column_status" | translate }}</span>
    @if ( sortValue === 'progress' && sortOrder == 'up') {
    <span>
      <fa-icon [icon]="faCaretUp"></fa-icon>
    </span>
    } @else {
    <span>
      <fa-icon
        [icon]="faCaretDown"
        [ngClass]="sortValue === 'progress' ? '' : 'deactivate'"
      ></fa-icon>
    </span>
    }
  </a>
</th>
